module.exports = __webpack_public_path__ + "img/logo.324e1c13.svg";